<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<footer class="footer" data-testid="footer">
  @if (!isPohPage && !isAPohPdp && showNewsletter) {
    <app-subscribe-newsletter [showSubmitLabel]="false" [newsletterSource]="'newsletter-footer'" />
  }

  <div class="footer_container">
    <div class="container">
      <div class="row">
        <section class="footer-links col-sm-12 col-lg-10" [ngClass]="{ 'col-lg-12': localeId === 'fr-FR' }">
          <!-- SITE LINKS -->
          <ul id="footer_links" class="list-unstyled row">
            @for (item of footerLinks[localeId]; track item.title) {
              <li class="col-lg-3 col-12 mobile-border-bottom" (click)="openDropdown(item.title)">
                <div class="footer-links__title-container" [ngStyle]="{ minHeight: titleHeight + 'px' }">
                  <h2 class="footer-links__title dropdown-toggle">
                    {{ item.title }}
                  </h2>
                </div>
                @if (item.links) {
                  <!-- {{ openDropdownTitle() }} -->
                  <div
                    class="footer-links__dropdown"
                    [ngClass]="{ shown: openDropdownTitle() === item.title, hidden: openDropdownTitle() !== item.title }"
                  >
                    <ul class="list-unstyled ul-padding">
                      @for (item of item.links; track item.title) {
                        <li [attr.data-id]="item.title">
                          @if (item.link !== 'account') {
                            <a target="_blank" [attr.data-internal-id]="item.title" [href]="item.link">
                              {{ item.title }}
                            </a>
                          } @else {
                            @if (isLogged$ | async) {
                              <a tabindex="0" target="_blank" [href]="accountUrl" [attr.data-internal-id]="item.title">
                                {{ item.title }}
                              </a>
                            } @else {
                              <a tabindex="0" target="_blank" [href]="loginUrl" [attr.data-internal-id]="item.title">
                                {{ item.title }}
                              </a>
                            }
                          }
                        </li>
                      }
                    </ul>
                  </div>
                }
              </li>
            }
          </ul>
        </section>
        @if (localeId !== 'fr-FR') {
          <section id="footer_social" class="col-lg-2">
            <div
              class="footer-links__title-container"
              [ngStyle]="{ minHeight: titleHeight + 'px' }"
              (click)="openDropdown('footer_social')"
            >
              <h2 class="footer-links__title dropdown-toggle" i18n="@@LEARN_MORE">Learn more</h2>
            </div>
            <div
              class="footer-links__dropdown"
              [ngClass]="{ shown: openDropdownTitle() === 'footer_social', hidden: openDropdownTitle() !== 'footer_social' }"
            >
              <ul class="list-unstyled ul-padding">
                <li>
                  <a
                    data-gtmaction="socialmedia_exit"
                    data-gtmcategory="event_social_action"
                    data-gtmlabel="instagram"
                    href="https://www.instagram.com/oralb.es/?hl=es"
                    target="_blank"
                    (click)="gtmEvent($event)"
                  >
                    <i class="fab fa-instagram"></i> <span>Instagram</span>
                  </a>
                </li>
                <li>
                  <a
                    data-gtmaction="socialmedia_exit"
                    data-gtmcategory="event_social_action"
                    data-gtmlabel="facebook"
                    href="https://www.facebook.com/oralbes"
                    target="_blank"
                    (click)="gtmEvent($event)"
                  >
                    <i class="fab fa-facebook"></i> <span>Facebook</span>
                  </a>
                </li>
                <li>
                  <a
                    data-gtmaction="socialmedia_exit"
                    data-gtmcategory="event_social_action"
                    data-gtmlabel="youtube"
                    href="https://www.youtube.com/channel/UCs4odz51M7K-gydteVI38xQ"
                    target="_blank"
                    (click)="gtmEvent($event)"
                  >
                    <i class="fab fa-youtube"></i> <span>Youtube.com</span>
                  </a>
                </li>
              </ul>
            </div>
          </section>
        }
        <section id="footer_payment-methods" class="col-lg-12 col-6">
          <h2 class="footer-links__title" i18n="@@PAY_SECURELY">Pay securely with</h2>
          <!-- PAYMENT METHODS -->
          <app-payment-methods />
        </section>
        <section id="footer_bottom" class="col-lg-12 col-6">
          <ul class="footer_bottom-links list-unstyled">
            <li>
              <a [href]="'https://preferencecenter.pg.com/' + localIdLowerCase + '/'" i18n="@@MY_DATA">My Data</a>
              @if (localeId === 'fr-FR') {
                <a href="https://preferencecenter.pg.com/fr-be/" i18n="@@MY_DATA_BE">My Data - BE</a>
              }
            </li>
            <li>
              <a href="docs/cgv" i18n="@@TERMS_CONDITIONS">Terms and conditions</a>
            </li>
            @if (localeId === 'fr-FR') {
              <li>
                <a href="https://fr.pg.com/company-information/">Mentions lègales</a>
              </li>
            }
            <li>
              <a href="docs/rp" i18n="@@RETURN">Return policy</a>
            </li>
            <li>
              <a href="docs/privacy" i18n="@@PRIVACY">Privacy</a>
            </li>
            <li class="d-none d-sm-block" [ngClass]="{ 'cr-text': localeId === 'fr-FR' }">
              ©{{ currentYear }} Procter & Gamble
            </li>
          </ul>

          <button
            type="button"
            onclick="Optanon.ToggleInfoDisplay();"
            name="btnOneTrust"
            id="btnOneTrust"
            class="btnOneTrust"
            i18n="@@COOKIES"
          >
            Consenso ai cookie
          </button>
        </section>
        <div class="d-sm-none cr-text-mobile">©{{ currentYear }} Procter & Gamble</div>
        @if (localeId === 'fr-FR') {
          <div class="aws-address">Hébergeur: Amazon Web Services - 410 Terry Avenue North Seattle, WA 98109-5210 USA</div>
        }
      </div>
    </div>
  </div>
</footer>

@if (!isPohPage && !isAPohPdp && showNewsletter) {
  <app-newsletter-modal />
}
